import React from "react";
import { FormGroup, Label } from "./externals";
export const CustomLabel = ({ children, text, inline, className, style, }) => {
    if (inline) {
        return (React.createElement(FormGroup, { inline: true, label: text, className: className, style: style }, children));
    }
    else {
        return (React.createElement(Label, { className: className, style: style },
            text,
            children));
    }
};
//# sourceMappingURL=CustomLabel.js.map